import dynamic from 'next/dynamic';

import { CopyBlockBlockProps } from 'src/components/blocks/CopyBlockBlock';
import { ContentBlockRenderer } from '../../../types/Block';
import { Transformer } from '../../../types/Transformer';
import { CopyBlockContentSection } from './types';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<CopyBlockBlockProps> = dynamic<CopyBlockBlockProps>(
  () => import('../../../components/blocks/CopyBlockBlock').then((mod) => mod.CopyBlockBlock),
);

export const transformer: Transformer<CopyBlockContentSection, CopyBlockBlockProps> = ({
  _metadata,
  copy,
  alignment,
  tracking_title,
}) => ({
  uid: _metadata.uid,
  props: {
    children: copy,
    alignment,
    trackingTitle: tracking_title,
  },
});
